import axios from "axios";

// Same-origin deploy rule: NEVER use REACT_APP_BACKEND_URL.
const BACKEND_URL =
  (typeof window !== "undefined" && window.location.origin) || "";

console.log("[API] BACKEND_URL =", BACKEND_URL);

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 20000,
});

// Attach admin token if present
api.interceptors.request.use((config) => {
  const token =
    typeof window !== "undefined"
      ? window.localStorage.getItem("otelpro_admin_token")
      : null;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && window.location.pathname.startsWith("/admin")) {
      window.localStorage.removeItem("otelpro_admin_token");
    }
    return Promise.reject(err);
  }
);

export const WHATSAPP_NUMBER = "905327371306";
export const WHATSAPP_DISPLAY = "0532 737 13 06";
export const CONTACT_EMAIL = "info@otel-ekipmanlari.com";
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_otel-yerlesim/artifacts/izskkfcr_otel-pro-logo-transparent.png";

export const waLink = (msg = "") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export default api;
